import Button from 'src/components/button/Button';
import PadlockSvg from 'src/components/svg/PadlockSvg';
import theme from 'src/components/themes/DefaultTheme';
import { useUserContext } from 'src/lib/contexts/UserContext';
import styled from "src/lib/styles/css";

//#region [Styles]
const SButton = styled(Button)`
	color: var(--inlinelinkcolor);
	padding: 0 0 0 20%;
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: flex-start;
	font-size: ${theme.fonts.buttontextL.size};

	svg {
		max-height: none;
		height: auto;
		width: 20px;
		flex: 0 0 auto;
		margin: 0 5px;
	}

	path {
		fill: var(--inlinelinkcolor);
	}

`;

//#endregion

//#region [Props]
type LogoutButtonProps = {
	className?: string;
};
//#endregion

//#region [Component]
export default function LogoutButton({ className }: LogoutButtonProps) {
	const authContext = useUserContext();
	return (
		<SButton className={className} onClick={authContext.doLogout} text="Logg ut" icon={<PadlockSvg isOpen />} />
	);
}
//#endregion